import { BaseAPIRequestFactory, RequiredError } from './baseapi.js';
import { HttpMethod, HttpInfo } from '../http/http.js';
import { ObjectSerializer } from '../models/ObjectSerializer.js';
import { ApiException } from './exception.js';
import { isCodeInRange } from '../util.js';
export class ListInventoryEnvironmentsApiRequestFactory extends BaseAPIRequestFactory {
    async listInventoryEnvironments(projectId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("ListInventoryEnvironmentsApi", "listInventoryEnvironments", "projectId");
        }
        const localVarPath = '/projects/{projectId}/inventory/environments'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
}
export class ListInventoryEnvironmentsApiResponseProcessor {
    async listInventoryEnvironmentsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ListInventoryEnvironmentsResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
}
